export var CommonProps = {
  rankList: {
    type: Array,
    required: true,
    default: () => []
  },
  own: {
    type: [Object, Array],
    required: true,
    default: () => ({})
  },
  highlightTop3: {
    type: Boolean,
    required: false,
    default: true
  },
  unit: {
    type: String,
    default: '分'
  },
  headerScore: {
    type: String,
    default: '总分'
  },
  openUserProfile: {
    type: [Boolean, Number],
    required: false,
    default: false
  },
  showHeader: {
    type: Boolean,
    required: false,
    default: true
  },
  showBottom: {
    type: Boolean,
    required: false,
    default: true
  },
  showPointUnit: {
    type: Boolean,
    required: false,
    default: false
  },
  fixedBottom: {
    type: Boolean,
    required: false,
    default: false
  },
  emptySeatText: {
    type: String,
    required: false,
    default: '虚位以待'
  },
  showEmptyText: {
    type: [Boolean, Function],
    required: false,
    default: false
  },
  emptyText: {
    type: String,
    required: false,
    default: '暂无数据'
  },
  imgConfig: {
    type: Object,
    required: false,
    default: () => ({})
  },
  formatScore: {
    type: Function,
    required: false,
    default: val => {
      return Number.parseFloat(val).toFixed(0);
    }
  }
};